"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
const analytics_js_1 = require("@hh.ru/analytics-js");
/** Успешный отклик соискателя после нажатия на кнопку Откликнуться:<ul><li>в карточке вакансии в поиске</li><li>на карте</li><li>на странице вакансии</li></ul> */
const vacancyResponseCompleteFeedStorageExternal = ({ params }) => analytics_js_1.VendorAnalytics.eventToStorage("applicant", "response-sent-complete-feed", "", undefined, params);
exports.default = vacancyResponseCompleteFeedStorageExternal;
